import Game from "./components/Game";
import {AppContextOpts, AppContext} from "./context/appContext";
import {useContext} from "react";
import {ThemeContext} from "styled-components";

function App(props: AppContextOpts) {
	const t = useContext(ThemeContext)
  return (<>
			<AppContext.Provider value={props}>
				<Game />
			</AppContext.Provider>
		</>
  );
}

export default App;
